<template>
    <div v-if="languages && languages.length > 1">
        <font-awesome-icon icon="globe-americas" />
        <select v-model="selectedLanguage" @change="changeLanguage" class="cursor-pointer bg-purple-mobile-switch-language">
            <option v-for="code in languages" :key="code" :value="code">
                {{ code.toUpperCase() }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    name: "SwitchLanguage",
    data() {
        return {
            selectedLanguage: window.languages[Object.keys(window.languages)[0]],
        };
    },
    computed: {
        languages() {
            return window.languages;
        },
    },
    methods: {
        changeLanguage() {
            this.$i18n.locale = this.selectedLanguage;
            this.$inertia.post(route('user.setLanguage').url(), { language: this.selectedLanguage }, { preserveScroll: true });
        },
    },
    mounted() {
        this.selectedLanguage = this.$i18n.locale;
    },
}
</script>

<style lang="scss" scoped>
@media (max-width: 767px) {
    .bg-purple-mobile-switch-language {
        background-color: #6c2bd9;
        background-color: rgba(108, 43, 217, var(--bg-opacity));
    }
}
</style>
